import { render, staticRenderFns } from "./AccessDenied.vue?vue&type=template&id=35a94bd9&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src567975772/src/search.myaileron.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a94bd9')) {
      api.createRecord('35a94bd9', component.options)
    } else {
      api.reload('35a94bd9', component.options)
    }
    module.hot.accept("./AccessDenied.vue?vue&type=template&id=35a94bd9&", function () {
      api.rerender('35a94bd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccessDenied.vue"
export default component.exports